(function () {
  function demote(el) {
    var p = document.createElement('p');
    p.className = el.className;
    if (el.id) p.id = el.id;
    p.innerHTML = el.innerHTML;
    el.replaceWith(p);
  }

  function fixHeadings() {
    var h1 = document.querySelector('main h1');
    if (h1) {
      var t = h1.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      document.querySelectorAll('main .product h2, main product-info h2').forEach(function (h) {
        if (h.textContent.replace(/\s+/g, ' ').trim().toLowerCase() === t) demote(h);
      });
    }
    document.querySelectorAll('h2.visually-hidden').forEach(function (h) {
      if (h.closest('.menu-drawer, header-drawer, .header, footer')) demote(h);
    });
    document.querySelectorAll('footer .localization-form h2, footer .footer__localization h2').forEach(demote);
  }

  function initFaq() {
    document.querySelectorAll('[data-cedar-faq]').forEach(function (wrap) {
      wrap.querySelectorAll('.cedar-faq__btn').forEach(function (btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        btn.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.hidden = open;
        });
      });
    });
  }

  function closeDropdown(dd) {
    var btn = dd.querySelector('.cedar-dd__btn');
    var list = dd.querySelector('.cedar-dd__list');
    btn.setAttribute('aria-expanded', 'false');
    list.hidden = true;
  }

  function initDropdown(dd) {
    if (dd.dataset.ready) return;
    dd.dataset.ready = '1';
    var btn = dd.querySelector('.cedar-dd__btn');
    var list = dd.querySelector('.cedar-dd__list');
    var select = dd.querySelector('select');
    function open() {
      btn.setAttribute('aria-expanded', 'true');
      list.hidden = false;
      var sel = list.querySelector('[aria-selected="true"]') || list.firstElementChild;
      if (sel) sel.focus();
    }
    function pick(opt) {
      var value = opt.getAttribute('data-value');
      closeDropdown(dd);
      btn.focus();
      if (select.value === value) return;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      btn.querySelector('.cedar-dd__value').textContent = value;
      var img = opt.querySelector('img');
      var cur = btn.querySelector('.cedar-dd__logo');
      if (img && cur) cur.src = img.src;
      list.querySelectorAll('[role="option"]').forEach(function (o) {
        o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
      });
    }
    btn.addEventListener('click', function () {
      if (list.hidden) open(); else closeDropdown(dd);
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    list.addEventListener('click', function (e) {
      var opt = e.target.closest('[role="option"]');
      if (opt) pick(opt);
    });
    list.addEventListener('keydown', function (e) {
      var opts = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
      var i = opts.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || opts[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (opts[i]) pick(opts[i]); }
      else if (e.key === 'Escape') { closeDropdown(dd); btn.focus(); }
    });
  }

  function initDropdowns() {
    document.querySelectorAll('[data-cedar-dd]').forEach(initDropdown);
  }
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-cedar-dd]').forEach(function (dd) {
      if (!dd.contains(e.target)) closeDropdown(dd);
    });
  });

  function initCarousels() {
    document.querySelectorAll('[data-cedar-carousel]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var track = wrap.querySelector('[data-carousel-track]');
      var prev = wrap.querySelector('[data-carousel-prev]');
      var next = wrap.querySelector('[data-carousel-next]');
      function update() {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8 }); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function moveProgramSelect() {
    var box = document.querySelector('[data-cedar-prog]');
    var target = document.querySelector('.facets-container');
    if (!box || !target || box.classList.contains('is-moved')) return;
    box.classList.add('is-moved');
    target.insertBefore(box, target.firstChild);
  }

  function init() {
    fixHeadings();
    initFaq();
    initDropdowns();
    initCarousels();
    moveProgramSelect();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  new MutationObserver(function () { initDropdowns(); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
